import theme from "../../theme";

export default function Header_sp() {
    return (
        <header
            style={{ 
                color: theme.palette.header.color,
                fontFamily: theme.typography.header.fontFamily,
                fontWeight: theme.typography.header.fontWeight,
                backgroundColor: theme.palette.header.bgColor,
            }}
            className="inline-block mx-0 my-3 rounded-e-lg"
        >
            <h1 className="text-sm px-9 py-4">TONPEKE</h1>
        </header>
    );
}
